import React, { useState } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import {
  Container, FieldsArea, RadioArea, RadioStyled
} from './styles'
import Label from '@components/inputs/label'

const RadioButtons = ({
  options,
  title,
  required,
  onChange,
}) => {
  const [selectedValue, setSelectedValue] = useState(false)

  const handleChange = (option) => {
    setSelectedValue(option)
    onChange(option)
  }

  return (
    <Container>
      {title && <Label label={title} required={required} />}
      <FieldsArea>
        {_.map(options, (option) => (
          <RadioArea
            onClick={() => handleChange(option)}
            selected={selectedValue === option}
            key={option}
          >
            <RadioStyled
              checked={selectedValue === option}
              value={option}
              name="radio-buttons"
              inputProps={{ 'aria-label': option }}
            />
            {option}
          </RadioArea>
        ))}
      </FieldsArea>
    </Container>
  )
}

RadioButtons.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
}

RadioButtons.defaultProps = {
  options: [],
  title: '',
  required: false
}

export default RadioButtons
